import React, { useState, useEffect, useCallback } from 'react';
import './App.css';
import flame from './flame.png'
import flameOut from './flameOut.png'
import SingleBar from './SingleBar';
import EloTime from './EloTime';
import SubscriptionForm from './SubscriptionForm'

function MathApp({cookie, conversions}) {
    const [data, setData] = useState('');
    const [dataRetrieved, setDataRetrieved] = useState(false)
    const [questionText, setQuestionText] = useState([]);
    const [answer, setAnswer] = useState('');
    const [lesson, setLesson] = useState(false);
    const [correct, setCorrect] = useState(0);
    const [showCorrect, setShowCorrect] = useState(false);
    const [correctAnswer, setCorrectAnswer] = useState(false)
    const [serverAnswer, setServerAnswer] = useState(null);
    const [streakUpdated, setStreakUpdated] = useState(false);
    const [XP, setXP] = useState(0);
    const [difficulty, setDifficulty] = useState(0);
    const [outConversionText, setOutConversionText] = useState('')
    const [questionBarColor, setQuestionBarColor] = useState('#4682B4')
    const [numberInputWidth, setNumberInputWidth] = useState(15)
    const [page, setPage] = useState("lesson");
    const [selectedOperators, setSelectedOperators] = useState(null);
    const stripeKey = 'pk_test_51JQjZwADngI2LS7y946Ny4IsciZaBssMMs7UB4GgrAFdkCcFrepPrJ6LPe6BRjPqg48uPzMyn8FnaawA20wApETd00Uig1iG1O';

    useEffect(() => {
        retrieveData(); 
    }, []);

    useEffect(() => {
      const checkboxes = Array.from(document.querySelectorAll('input[type="checkbox"]'));
      console.log(selectedOperators)
      if (selectedOperators !== undefined){
        for (let checkbox of checkboxes){
          checkbox.checked = selectedOperators.includes(checkbox.id)
        }
      }
    }, [selectedOperators])



    const addText = (val) => {
        setAnswer((prev) => (prev || "") + val);
      }

      const removeText = () => {
        setAnswer((prev) => prev.slice(0, -1));
      }

      const clearText = () => {
        setAnswer('');
      }

    const handleKeyPress = useCallback((event) => {
        if (page === 'lesson'){
          event.preventDefault(); // Prevent default button behavior 
        }

        if (event.key === 'F11'){
          if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
          } 
          else if (document.exitFullscreen) {
              document.exitFullscreen();
          }
        }

        if (event.key === 'F5'){
          window.location.reload()
        }
        
        console.log(event.key);
        let inputString = '0123456789.-'
        if (difficulty > 0){
          inputString += 'e'
        }
        if (difficulty > 0){
          inputString += 'x'
        }
        if (difficulty > 0){
          inputString += 'i+-'
        }
        if (difficulty > 0){
          inputString += '[] '
        }
        if (difficulty > 0){
          inputString += 'jk'
        }
        
        if (lesson){
            if (event.key === 'Enter') {
                submitAnswer();
              } else if (event.key === 'Backspace') {
                removeText(); // Remove last character
              } else if (inputString.includes(event.key)) {
                addText(event.key);
              }
              else if (event.key === 'Delete'){
                clearText();
              }
        } 
        else {
            if (event.key === 'Enter') {
                startLesson();
              }
        }   
      }, [addText, answer, removeText, clearText]);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyPress);
        return () => window.removeEventListener('keydown', handleKeyPress);
      }, [handleKeyPress]);

    const retrieveData = async () => {
        const response = await fetch(`/retrieve-data/${cookie}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })

        const data = await response.json();   
        console.log(data);
        setData(data);
        const now = Date.now();
        const day = Math.floor(now / 1000 / 86400)
        setStreakUpdated(day === data.data.streakDay)
        setXP(data.data.XP)
        setDifficulty(Math.floor(data.data.difficulty))
        setSelectedOperators(data.data['selectedOperators'].split(','))
        setDataRetrieved(true);
    }

    const getQuestion = async () => {
        setAnswer('');
        setOutConversionText('');
        const response = await fetch(`/get-question/${cookie}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })

        const question = await response.json();

        const numbers = question.data['numbers'];
        const symbols = question.data['symbols'];
        const complex = question.data['complex'];
        const quaternion = question.data['quaternion'];
        const vector = question.data['vector'];
        const matrix = question.data['matrix'];
        const brackets = question.data['brackets'];

        console.log(brackets)

        let baseWidth;

        if (complex){
          baseWidth = 20
        }
        else if (quaternion || vector){
          baseWidth = 30
        }
        else if (matrix){
          baseWidth = 40
        }
        else{
          baseWidth = 15
        }

        if (window.innerWidth < 1024){
          baseWidth *= 2
        }

        setNumberInputWidth(baseWidth)

        const symbolText = {
            '+': ' + ',
            '-': ' - ',
            '*': ' x ',
            'div': ' ÷ ',
            'fdiv': ' ÷ ',
            '%': ' % ',
            '!': '!',
            '^': '',
            'P': 'P',
            'C': 'C',
            'log': 'log',
            'flog': 'log',
            'irrLog': 'log',
            'sin': 'sin',
            'cos': 'cos',
            'tan': 'tan',
            'asin': 'asin',
            'acos': 'acos',
            'atan': 'atan',
            'cosec': 'cosec',
            'sec': 'sec',
            'cot': 'cot',
            'acosec': 'acosec',
            'asec': 'asec',
            'acot': 'acot',
            'calc': 'calc',
            'fn': 'fn',
            '|': '|',
            '.': ' . ',

            // Complex numbers
            'C+': ' + ',
            'C-': ' - ',
            'C*': ' x ',
            'Cdiv': ' ÷ ',
            'C^': '^',
            '||C||': '|| ||',
            '√C': '√',

            // Vectors
            'v+': ' + ',
            'v-': ' - ',
            '||v||': '|| ||',
            'v⋅w': '⋅',

            // Matrices
            'M+': ' + ',
            'M-': ' - ',
            'Mvv': '⊗',     // Outer product
            'MMv': ' x ',   // Matrix × vector
            'MMM': ' x ',   // Matrix × matrix
            '|M|': '| |',
            'M⁻¹': '⁻¹',
            'M^': '^',

            // Quaternions
            'Q+': ' + ',
            'Q-': ' - ',
            'Q*': ' x ',
            'Qdiv': ' ÷ ',
            '||Q||': '|| ||',
            'Q^': '^',
            'Q**': '**',

            // Misc special functions
            'erf': 'erf',
            'Γ': 'Γ',

            '|': '|',
            '.': ' . '
        }

        let addString = "";

        console.log(symbols);

        for (let i=0; i<numbers.length; i++){
          for (let j=0; j<=brackets.length; j++){
            if (brackets[j] == i && j % 2 == 0){
              addString += '('
            }
            else if (brackets[j] == i && j % 2 == 1){
              addString += ')'
            }
          }
            if (symbols[i] === 'fn'){
              addString += 'f(x) = '
              for (let j=numbers.length - 2; j>= 0; j--){
                addString += `${numbers[j] >= 0 ? (j < numbers.length - 2 ? '+' : '') : '-'} ${Math.abs((numbers[j]) > 1) || j === 0 && (Math.abs(numbers[j]) > 0) ? Math.abs(numbers[j]) : ''}${j > 0 ? 'x': ''}<sup>${j > 1 ? j : ''}</sup>`
                addString += `${numbers[j] >= 0 ? (j < numbers.length - 2 ? '+' : '') : '-'} ${Math.abs((numbers[j]) > 1) || j === 0 && (Math.abs(numbers[j]) > 0) ? Math.abs(numbers[j]) : ''}${j > 0 ? 'x': ''}<sup>${j > 1 ? j : ''}</sup>`
              }

              addString += `, x = ${numbers[numbers.length - 1]}`
              break;
            }
            if (symbols[i] === 'calc'){
              addString += `<sup>d</sup>/<sub>dx</sub>(`
              for (let j=numbers.length - 2; j>= 0; j--){
                addString += `${numbers[j] >= 0 ? (j < numbers.length - 2 ? '+' : '') : '-'} ${Math.abs((numbers[j]) > 1) || j === 0 && (Math.abs(numbers[j]) > 0) ? Math.abs(numbers[j]) : ''}${j > 0 ? 'x': ''}<sup>${j > 1 ? j : ''}</sup>`
              }
              addString += `), x = ${numbers[numbers.length - 1]}`
              break;
            }
            if (symbols[i] == 'int'){
              const lowerLimit = numbers[numbers.length - 1][0];
              const upperLimit = numbers[numbers.length - 1][1];
              addString += `∫<sub>${lowerLimit}</sub><sup>${upperLimit}</sup>(`
              for (let j=numbers.length - 2; j>= 0; j--){
                addString += `${numbers[j] >= 0 ? (j < numbers.length - 2 ? '+' : '') : '-'} ${Math.abs((numbers[j]) > 1) || j === 0 && (Math.abs(numbers[j]) > 0) ? Math.abs(numbers[j]) : ''}${j > 0 ? 'x': ''}<sup>${j > 1 ? `${j} ` : ''}</sup>`
              }
              addString += `) dx`
              break;
            }
            if (symbols[i] === 'sqrt'){
              addString += `&radic;<msqrt style={{"border-top": "2px solid"}}>${numbers[i].toString()}</msqrt></span>`
                continue;
            }
            if (i !== numbers.length - 1) {
                if (symbols[i] === '^' && !complex) {
                  addString += `${numbers[i].toString()}${symbolText[symbols[i]]}<sup>${numbers[i + 1].toString()}</sup>`
                  // Skip the next number as it's already used as the exponent
                  i++;
                  // If there is another symbol, display it:
                  if (i <= symbols.length - 1){
                    addString += `${symbolText[symbols[i]]}`
                  }
                }
                else if (symbols[i] === '^' && complex){
                    addString += `(${numbers[i][0] >= 0 ? '' : '-'}${Math.abs(numbers[i][0].toString())} ${numbers[i][1] >= 0 ? '+' : '-'} ${Math.abs(numbers[i][1]) > 1 ? Math.abs(numbers[i][1].toString()) : ''}i)
                    ${symbolText[symbols[i]]}
                    <sup>${numbers[i + 1].toString()}</sup>`
                  // Skip the next number as it's already used as the exponent
                  i++;
                  // If there is another symbol, display it:
                  if (i <= symbols.length - 1){
                    addString += `${symbolText[symbols[i]]}`
                  }
                }
                else if (symbols[i] === '^' && quaternion){
                  addString += `(${numbers[i][0] >= 0 ? '' : '-'}${Math.abs(numbers[i][0]) > 0 ? Math.abs(numbers[i][0]).toString() : ''} ${numbers[i][1] >= 0 ? '+' : '-'} ${Math.abs(numbers[i][1]) > 1 ? Math.abs(numbers[i][1]).toString() : ''}i ${numbers[i][2] >= 0 ? '+' : '-'} ${Math.abs(numbers[i][2]) > 1 ? Math.abs(numbers[i][2]).toString() : ''}j ${numbers[i][3] >= 0 ? '+' : '-'} ${Math.abs(numbers[i][3]) > 1 ? Math.abs(numbers[i][3]).toString() : ''}k)
                  ${symbolText[symbols[i]]}
                  <sup>${numbers[i + 1].toString()}</sup>`
                  i++;
                  if (i <= symbols.length - 1){
                    addString += `${symbolText[symbols[i]]}`
                  }
                }
                else if (symbols[i] == 'log' || symbols[i] == 'flog' || symbols[i] == 'irrlog'){
                  addString += `${symbolText[symbols[i]]}<sub>${numbers[i].toString()}</sub>${numbers[i + 1].toString()}`
                      // Skip the next number as it's already used as the exponent
                      i++;
                      // If there is another symbol, display it:
                      if (i <= symbols.length - 1){
                        addString += `${symbolText[symbols[i]]}`
                      }
                } else if (!complex && !vector && !matrix && !quaternion) {
                  addString += `${numbers[i].toString()} ${symbolText[symbols[i]]}`
                }
                else if (complex){
                  addString += `(${numbers[i][0] >= 0 ? '' : '-'}${Math.abs(numbers[i][0].toString())} ${numbers[i][1] >= 0 ? '+' : '-'} ${Math.abs(numbers[i][1]) > 1 ? Math.abs(numbers[i][1].toString()) : ''}i)
                  ${symbolText[symbols[i]]}`
                }
                else if (quaternion){
                  addString += `(${numbers[i][0] >= 0 ? '' : '-'}${Math.abs(numbers[i][0]) > 0 ? Math.abs(numbers[i][0]).toString() : ''} ${numbers[i][1] >= 0 ? '+' : '-'} ${Math.abs(numbers[i][1]) > 1 ? Math.abs(numbers[i][1]).toString() : ''}i ${numbers[i][2] >= 0 ? '+' : '-'} ${Math.abs(numbers[i][2]) > 1 ? Math.abs(numbers[i][2]).toString() : ''}j ${numbers[i][3] >= 0 ? '+' : '-'} ${Math.abs(numbers[i][3]) > 1 ? Math.abs(numbers[i][3]).toString() : ''}k)
                  ${symbolText[symbols[i]]}`
                }
                else if (vector){
                  addString += `[${numbers[i][0].toString()} ${numbers[i][1].toString()}] ${symbolText[symbols[i]]}`
                }
                else if (matrix){
                  const rowLength = Math.sqrt(numbers.length)
                  addString += '['
                  for (let j=0; j<rowLength; j++){
                    addString += '['
                    for (let k=0; k<rowLength; k++){
                        addString += (k !== rowLength - 1) ? `${numbers[i][j][k].toString()} ` : `${numbers[i][j][k].toString()}`;
                    }
                      addString += ']\n'
                  }
                  addString += `]\n${symbolText[symbols[i]]}`
                }
              } else if (matrix){
                const rowLength = Math.sqrt(numbers.length)
                  let addString = '['
                  for (let j=0; j<rowLength; j++){
                    addString += '['
                    for (let k=0; k<rowLength; k++){
                      addString += (k !== rowLength - 1) ? `${numbers[i][j][k].toString()} ` : `${numbers[i][j][k].toString()}`;            
                    }
                    addString += ']\n'
                  }
                  addString += ']'
              }
              else if (vector && symbols[i] === '|'){
                addString += `||[${numbers[i][0].toString()} ${numbers[i][1].toString()}]||`
              }
              else if (vector){
                addString += `[${numbers[i][0].toString()} ${numbers[i][1].toString()}]`
              }

              else if (complex && symbols[i] === '|') {
                addString += `|${numbers[i][0] >= 0 ? '' : '-'}${Math.abs(numbers[i][0].toString())} ${numbers[i][1] >= 0 ? '+' : '-'} ${Math.abs(numbers[i][1].toString())}i|`
              }
              else if (complex) {
                addString += `(${numbers[i][0] >= 0 ? '' : '-'}${Math.abs(numbers[i][0].toString())} ${numbers[i][1] >= 0 ? '+' : '-'} ${Math.abs(numbers[i][1].toString())}i)`
              }
              else if (quaternion && symbols[i] === '|'){
                addString += `|${numbers[i][0] >= 0 ? '' : '-'}${Math.abs(numbers[i][0]) > 0 ? Math.abs(numbers[i][0]).toString() : ''} ${numbers[i][1] >= 0 ? '+' : '-'} ${Math.abs(numbers[i][1]) > 1 ? Math.abs(numbers[i][1]).toString() : ''}i ${numbers[i][2] >= 0 ? '+' : '-'} ${Math.abs(numbers[i][2]) > 1 ? Math.abs(numbers[i][2]).toString() : ''}j ${Math.abs(numbers[i][3]) >= 0 ? '+' : '-'} ${Math.abs(numbers[i][3]) > 1 ? Math.abs(numbers[i][3]).toString() : ''}k|` 
              }
              else if (quaternion){
                addString += `(${numbers[i][0] >= 0 ? '' : '-'}${Math.abs(numbers[i][0]) > 0 ? Math.abs(numbers[i][0]).toString() : ''} ${Math.abs(numbers[i][1]) >= 1 ? '+' : '-'} ${Math.abs(numbers[i][1]) > 1 ? Math.abs(numbers[i][1]).toString() : ''}i ${Math.abs(numbers[i][2]) >= 1 ? '+' : '-'} ${Math.abs(numbers[i][2]) > 1 ? Math.abs(numbers[i][2]).toString() : ''}j ${Math.abs(numbers[i][3]) >= 1 ? '+' : '-'} ${Math.abs(numbers[i][3]) > 1 ? Math.abs(numbers[i][3]).toString() : ''}k)` 
              }
              else {    
                addString +=  `${numbers[i].toString()}`         
                if (symbols[i] === '!'){
                  addString += `${symbolText[symbols[i]]}`
                }
                for (let j=0; j<conversions.length; j++){
                    if (symbols[i] === conversions[j]){
                        console.log("Matched conversion")
                        const from = symbols[i].split('-')[0];
                        const to = symbols[i].split('-')[1];
                        console.log(conversions[j])
                        console.log(from, to)
                        addString += `${from}`
                        setOutConversionText(to)
                        break;
                    }
                }
              }          
        }

        for (let j=0; j<=brackets.length; j++){
          if (brackets[j] == numbers.length && j % 2 == 0){
            addString += '('
          }
          else if (brackets[j] == numbers.length && j % 2 == 1){
            addString += ')'
          }
        }

        addString += ' = '
        setQuestionText(addString);
    }

    const startLesson = async () => {
        setLesson(true);

        let checkedSymbols = [];
    
        if (data.data.premium) {
            const checkedCheckboxes = document.querySelectorAll('input[type="checkbox"]:checked');
            checkedSymbols = Array.from(checkedCheckboxes).map(checkbox => checkbox.id);
        }
        
        var url;
        if (checkedSymbols.length == 0){
          url = `/start-lesson/${cookie}`
        }
        else {
          url = `/start-lesson/${cookie}/${checkedSymbols}`
        }
        await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        const inputElement = document.getElementsByClassName('numberInput')[0];

        // Make the input element unselectable
        inputElement.style.pointerEvents = 'none';    
        getQuestion();
    }

    const showCorrectTemp = async () => {
        setShowCorrect(true);
        setTimeout(() => {
            setShowCorrect(false);
            setQuestionBarColor('#4682B4')
        }, 1000);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {      
        if (lesson && correct >= 100) {
            retrieveData();
            setCorrect(0);
            setLesson(false);
        }
    }, [correct]);

    const submitAnswer = async () => {
        console.log("Submitting answer");
        console.log(answer.length)
        if (answer !== ""){
            const response = await fetch(`/submit-answer/${cookie}/${answer}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            })

            const data = await response.json();
            console.log(data.correct);
            console.log(data.answer);
            setServerAnswer(data.answer)
            if (data.correct && !data.timeout){     
                setCorrect(correct + 3) 
                showCorrectTemp();
                setCorrectAnswer("Excellent!")
                setQuestionBarColor('#34C759')
            }
            else if (data.correct){
                setCorrect(correct + 2) 
                setCorrectAnswer("Correct")
                showCorrectTemp();
                setQuestionBarColor('#707070')
            }
            else {
                showCorrectTemp();
                setCorrectAnswer("Incorrect")
                setQuestionBarColor('#FF3737')
            }
            getQuestion();
            setAnswer('');
        }
        
    }

    const determinePercentage = (target) => {
        var output = 0;
        if (difficulty > target){
            output = 100;
        }
        else {
            output = 100 / (1 + Math.log(target/difficulty))
        }
        return output;
    }

    const mathConcepts = [
      { name: "Addition", value: 1, symbol: "+" },
      { name: "Subtraction", value: 10, symbol: "-" },
      { name: "Multiplication", value: 25, symbol: "*" },
      { name: "Negative Numbers", value: 50, symbol: "neg" }, 
      { name: "Division", value: 75, symbol: "div" },
      { name: "Exponents", value: 100, symbol: "^" },
      { name: "Length Conversions", value: 250, symbol: "lenConv" }, 
      { name: "Time Conversions", value: 500, symbol: "timeConv" },
      { name: "Modulus", value: 500, symbol: "%" }, 
      { name: "Mass Conversions", value: 750, symbol: "massConv" },
      { name: "Rational Division", value: 750, symbol: "fdiv" },
      { name: "Volume Conversions", value: 1000, symbol: "volConv" },
      { name: "Longer Expressions", value: 1000, symbol: ">" },
      { name: "Brackets", value: 1250, symbol: "()" },
      { name: "Temperature Conversions", value: 1500, symbol: "tempConv" },
      { name: "Factorials", value: 1500, symbol: "!" },
      { name: "Angle Conversions", value: 2000, symbol: "angConv" },
      { name: "Energy Conversions", value: 2500, symbol: "energyConv" },
      { name: "Permutations", value: 2500, symbol: "P" }, 
      { name: "Combinations", value: 2750, symbol: "C" },

      { name: "Currency Conversions", value: 3000, symbol: "currConv" },  
    
      { name: "Discrete Logarithms", value: 3000, symbol: "log" },
      { name: "Square Roots", value: 4000, symbol: "√" },
      { name: "Logarithms", value: 4500, symbol: "flog" },
      { name: "Rational Exponents", value: 5000, symbol: "f^" },
    
      //Conversions - Scientific (adjust as needed)
      { name: "Scientific Conversions", value: 7500, symbol: "sciConv" }, //Interpolated
    
      { name: "Sine", value: 8125, symbol: "sin" }, // interpolated
      { name: "Cosine", value: 8750, symbol: "cos" }, // interpolated
      { name: "Tangent", value: 9375, symbol: "tan" }, // interpolated
    
      { name: "Inverse Sine", value: 10000, symbol: "asin" }, // interpolated
      { name: "Inverse Cosine", value: 10833, symbol: "acos" }, // interpolated
      { name: "Inverse Tangent", value: 11667, symbol: "atan" }, // interpolated
    
      // Alternative Trigonometric Functions
    { name: "Secant", value: 12500, symbol: "sec" },    //Interpolated
    { name: "Cosecant", value: 12916, symbol: "cosec" },  //Interpolated
    { name: "Cotangent", value: 13333, symbol: "cot" },  //Interpolated

     { name: "Inverse Secant", value: 13750, symbol: "asec" },    //Interpolated
     { name: "Inverse Cosecant", value: 14166, symbol: "acosec" },  //Interpolated
     { name: "Inverse Cotangent", value: 14583, symbol: "acot" },  //Interpolated

      // Hyperbolic Trigonometric Functions
    { name: "Hyperbolic Sine", value: 15000, symbol: "sinh" }, // Interpolated
    { name: "Hyperbolic Cosine", value: 15833, symbol: "cosh" }, // Interpolated
    { name: "Hyperbolic Tangent", value: 16666, symbol: "tanh" }, // Interpolated
    { name: "Hyperbolic Secant", value: 17500, symbol: "sech" }, // Interpolated
    { name: "Hyperbolic Cosecant", value: 18333, symbol: "cosech" }, // Interpolated
    { name: "Hyperbolic Cotangent", value: 19166, symbol: "coth" }, // Interpolated

      { name: "Function Evaluation", value: 20000, symbol: "f(x)" },
    
      { name: "Calculus", value: 23333, symbol: "calc" },
      { name: "Integration", value: 26667, symbol: "int" },
    
      { name: "Complex Addition", value: 30000, symbol: "C+" }, //Interpolated
      { name: "Complex Subtraction", value: 31250, symbol: "C-" }, //Interpolated
      { name: "Complex Multiplication", value: 32500, symbol: "C*" }, //Interpolated
      { name: "Complex Division", value: 33750, symbol: "Cdiv" }, //Interpolated
      { name: "Complex Norm", value: 35000, symbol: "||C||" }, //Interpolated
      { name: "Complex Square Roots", value: 36250, symbol: "√C" }, //Interpolated
    
      { name: "Vectors - Addition", value: 37500, symbol: "v+" }, //Interpolated
      { name: "Vectors - Subtraction", value: 40000, symbol: "v-" }, //Added
      { name: "Vectors - Norm", value: 43333, symbol: "||v||" },
      { name: "Vectors - Dot Product", value: 46666, symbol: "v⋅w" },
    
      { name: "Irrational Logarithms", value: 50000, symbol: "irrLog" }, //Interpolated
      { name: "Irrational Exponents", value: 52500, symbol: "irr^" }, //Interpolated
    
      { name: "Matrices - Addition", value: 55000, symbol: "M+" },
      { name: "Matrices - Subtraction", value: 57500, symbol: "M-" }, //Added
      { name: "Matrices - Vector Vector Multiplication", value: 60000, symbol: "Mvv" },
      { name: "Matrices - Matrix Vector Multiplication", value: 65000, symbol: "MMv" },
      { name: "Matrices - Matrix Matrix Multiplication", value: 70000, symbol: "MMM" },
      { name: "Matrices - Determinant", value: 90000, symbol: "|M|" },
      { name: "Matrices - Inverse", value: 115000, symbol: "M⁻¹" },
      { name: "Matrices - Power", value: 125000, symbol: "M^" },
    
    
      { name: "Quaternions - Addition", value: 75000, symbol: "Q+" }, //Interpolated
      { name: "Quaternions - Subtraction", value: 75000, symbol: "Q-" }, //Added
      { name: "Quaternions - Multiplication", value: 80000, symbol: "Q*" },
      { name: "Quaternions - Division", value: 85000, symbol: "Qdiv" },
      { name: "Quaternions - Norm", value: 95000, symbol: "||Q||" },
      { name: "Quaternions - Power", value: 110000, symbol: "Q^" },
      { name: "Quaternions - Rotation", value: 120000, symbol: "Q**" },
    
      { name: "Error Function", value: 105000, symbol: "erf" },
      { name: "Gamma Function", value: 130000, symbol: "Γ" },
      ];

      const MathConceptsList = () => {
        return (
          <div>
            {mathConcepts.map((concept) => (
              <div key={concept.value}>
                {concept.name}  {data.data.premium && ( // Conditional rendering of checkbox
              <input
                type="checkbox"
                id = {concept.symbol}
                defaultChecked={concept.value < data.data.difficulty} // Set checked based on condition
              />
            )} <br />
                <SingleBar percentage={determinePercentage(concept.value)} /><br />
              </div>
            ))}
          </div>
        );
      };

      const exitLesson = () => {
        setCorrect(0);
        setLesson(false);
        retrieveData();
      }

    
    return (
        
        <div>
            {dataRetrieved && <>
                {!lesson && <>
                <div className = 'streak'>
                    {streakUpdated ? <img src={flame} alt='Flame Illuminated'/> : <img src = {flameOut} alt='Flame Extinguished'/>}
                    <span className='streakNumber'>{data.data['streak']} &nbsp;&nbsp;
                    XP {XP} &nbsp;&nbsp;
                    Elo {difficulty}
                    </span>
                </div>
                <nav><a onClick={() => {setPage("lesson")}}>Lessons</a><a onClick={() => {setPage("pro")}}>Settings</a></nav>
                {page === "lesson" && <>
                  <button className='startLesson' onClick = {startLesson}>Start Lesson</button><br/><br/>
                  <p className = 'details'>
                  <div className = 'skills'>
                  {MathConceptsList()}
                  </div>
                  The main thing that the Elo controls is the maximum size of the numbers used in the questions.<br/><br/>
                  Required precision increases with Elo.<br/><br/> 
                  Use a notebook if you wish to devise your own solving methodologies, but getting answers correct will not be enough to raise your Elo alone. You also need to be fast.<br/>
                </p>
                </>}
                {page === "pro" && !data.data.premium && <>Here are the benefits of our Pro membership, which gives you the ultimate control in your lesson planning!<br/>
                - Perform lessons in specific topics<br/>
                - Perform lessons in locked topics<br/>
                - Customise the elo algorithm to allow for longer form questions, rather than just mental math<br/>
                - The removal of all ads<br/>
                - Increased priority for the building of lower latency servers
                <SubscriptionForm stripeKey={stripeKey} cookie={cookie}/>
                </>}
                {page === "pro" && data.data.premium && <>
                <EloTime cookie={cookie}/><br/>
                Elo Time is the amount of time you have to answer a question before your elo decreases; even upon giving a correct answer.
                </>}
                
                </>}
                {lesson && (
                    <>
                    <button className = 'exitLesson' onClick={exitLesson}>Exit Lesson</button>
                    <div className='progress'>
                        <p>{correct}%</p>
                        <SingleBar className = 'progressBar' percentage={correct} color = {questionBarColor}/>    
                    </div>
                    <div className='questionContainer'>
                    <div className = 'correct'> {showCorrect && <> {correctAnswer} {serverAnswer}  </>}<br /></div>
                    <div className = 'question' dangerouslySetInnerHTML={{ __html: typeof questionText === 'string' ? questionText.replace("\n", "<br/>") : questionText }}></div>  
                    &emsp;
                    <input className = 'numberInput' style={{ width: `${numberInputWidth}vw`}} value={answer} readOnly={true}/>
                    <span className = 'question'>{outConversionText}</span>
                    <br/><br/><br/>
                    <button className='numberButton' onClick={() => {addText(1)}}>1</button><button className='numberButton' onClick={() => {addText(2)}}>2</button><button className='numberButton' onClick={() => {addText(3)}}>3</button><button className='numberButton' onClick={() => {removeText()}}>DEL</button>{difficulty > 35000 ? <button className='numberButton' onClick={() => {addText('[')}}>[</button> : <></>} {difficulty > 35000 ? <button className='numberButton' onClick={() => {addText(']')}}>]</button> : <></>}{difficulty > 35000 ? <button className='numberButton' onClick={() => {addText(' ')}}>_</button> : <></>}<br/>
                    <button className='numberButton' onClick={() => {addText(4)}}>4</button><button className='numberButton' onClick={() => {addText(5)}}>5</button><button className='numberButton' onClick={() => {addText(6)}}>6</button><button className='numberButton' onClick={() => {addText('-')}}>-</button>
                    {difficulty > 30000 ? <button className='numberButton' onClick={() => {addText('+')}}>+</button> : <></>}
                    <br/>
                    <button className='numberButton' onClick={() => {addText(7)}}>7</button><button className='numberButton' onClick={() => {addText(8)}}>8</button><button className='numberButton' onClick={() => {addText(9)}}>9</button>{difficulty > 500 ? <button className='numberButton' onClick={() => {addText('.')}}>.</button> : <></>}  {difficulty > 75000 ? <button className='numberButton' onClick={() => {addText('j')}}>j</button> : <></>}   
                    <br/>
                    <button className='numberButton' onClick={() => {addText(0)}}>0</button><button className='numberButton' onClick={() => {clearText()}}>CLS</button>
                    {difficulty > 7500 ? <button className='numberButton' onClick={() => {addText('e')}}>e</button> : <></>}
                    {difficulty > 23333 ? <button className='numberButton' onClick={() => {addText('x')}}>x</button> : <></>}
                    {difficulty > 30000 ? <button className='numberButton' onClick={() => {addText('i')}}>i</button> : <></>}{difficulty > 75000 ? <button className='numberButton' onClick={() => {addText('k')}}>k</button> : <></>}                     
                    <br/>                   
                    <button tabIndex = '-1' className='submitButton' onClick={submitAnswer}>Submit</button>
                    </div>
                    </>
                )}
                </>
            }
        </div>
    );
}

export default MathApp;
